import { join } from 'path-browserify'

import boxApi from './api'

export function useDelete() {
  const deleteFiles = async (selectedRows: any[], dir: string, domain: number) => {
    const failedList: any[] = []

    const resList = await Promise.allSettled(
      selectedRows.map(({ name, isDir }) => {
        return boxApi.delete('/vol', {
          params: {
            path: join(dir, name, isDir ? '/' : ''),
          },
          noErrMsg: true,
          domain,
        })
      }),
    )

    resList.forEach((res, index) => {
      if ((res.status === 'fulfilled' && res.value.code !== 0) || res.status === 'rejected') {
        failedList.push(selectedRows[index])
      }
    })

    return failedList
  }

  return {
    deleteFiles,
  }
}
